import { createFileRoute } from "@tanstack/react-router";
import { OfficerPerformancePanel } from "@/components/analytics/OfficerPerformancePanel";

export const Route = createFileRoute("/_authenticated/analytics/officers")({
  component: OfficersAnalytics,
  head: () => ({ meta: [{ title: "Officer performance — MissionReady" }] }),
});

function OfficersAnalytics() {
  return <OfficerPerformancePanel />;
}
